export interface SalesInvoiceCustomsSummaryReport {
  tariffCode: string;
  composition: string;
  nettQuantity: number;
  value: number;
}
